<template>
  <div class="register-tag-container">
    <h1>Register New Tag</h1>
    <p class="company-info">Company: <strong>{{ company }}</strong> (from login)</p>
    <form @submit.prevent="registerTag">
      <div class="form-group">
        <label>Tags (tag_mac, devicename)</label>
        <div class="tag-rows">
          <div v-for="(row, index) in tagRows" :key="index" class="tag-row">
            <div class="mac-input-wrap">
              <input
                v-model="row.tag_mac"
                placeholder="Tag MAC"
                class="tag-mac"
              />
              <button type="button" class="btn-scan" @click="startScan(index)" title="QR Scan">
                <span class="material-symbols-outlined">qr_code_scanner</span>
              </button>
            </div>
            <input
              v-model="row.devicename"
              placeholder="Device Name"
              class="devicename"
            />
            <button type="button" class="btn-remove" @click="removeRow(index)" title="Remove row">×</button>
          </div>
        </div>
        <button type="button" class="btn-add" @click="addRow">+ Add row</button>
      </div>
      <button type="submit" class="btn-submit">Register</button>
    </form>

    <!-- QR Scanner Modal -->
    <div v-if="showScanner" class="popup" @click.self="stopScan">
      <div class="scanner-content">
        <h3>QR Code Scan</h3>
        <div id="qr-reader"></div>
        <p v-if="scanError" class="scan-error">{{ scanError }}</p>
        <button type="button" class="btn-cancel" @click="stopScan">Cancel</button>
      </div>
    </div>

    <div v-if="showPopup" class="popup">
      <div class="popup-content">
        <h3>{{ popupMessage }}</h3>
        <button @click="closePopup">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Html5Qrcode } from 'html5-qrcode';

export default {
  name: 'RegisterTag',
  data() {
    return {
      gw_mac_parent: 'F0F5BD560062',
      tagRows: [
        { tag_mac: '', devicename: '' },
        { tag_mac: '', devicename: '' },
      ],
      showPopup: false,
      popupMessage: 'Complete',
      showScanner: false,
      scanTargetIndex: null,
      scanError: '',
      html5Qrcode: null,
    };
  },
  computed: {
    company() {
      return localStorage.getItem('company') || '';
    },
  },
  methods: {
    addRow() {
      this.tagRows.push({ tag_mac: '', devicename: '' });
    },
    removeRow(index) {
      if (this.tagRows.length <= 1) return;
      this.tagRows.splice(index, 1);
    },
    async registerTag() {
      if (!this.company) {
        this.popupMessage = 'Company not found. Please log in again.';
        this.showPopup = true;
        return;
      }
      const tags = this.tagRows
        .map((r) => ({ tag_mac: (r.tag_mac || '').trim(), devicename: (r.devicename || '').trim() }))
        .filter((r) => r.tag_mac);
      if (tags.length === 0) {
        this.popupMessage = 'Enter at least one Tag MAC.';
        this.showPopup = true;
        return;
      }
      try {
        const res = await axios.post('/api/registerTagBulk', {
          company: this.company,
          gw_mac_parent: (this.gw_mac_parent || '').trim() || 'F0F5BD560062',
          tags,
        });
        this.popupMessage = res.data.message || `Registered ${res.data.count} tag(s).`;
        this.showPopup = true;
        this.tagRows = [{ tag_mac: '', devicename: '' }, { tag_mac: '', devicename: '' }];
      } catch (error) {
        this.popupMessage = error.response?.data?.error || error.message || 'Failed to register tags.';
        this.showPopup = true;
      }
    },
    closePopup() {
      this.showPopup = false;
    },
    startScan(index) {
      this.scanTargetIndex = index;
      this.scanError = '';
      this.showScanner = true;
      this.$nextTick(() => {
        this.html5Qrcode = new Html5Qrcode('qr-reader');
        this.html5Qrcode.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          (decodedText) => {
            // QR에서 MAC 주소만 추출 (콜론/하이픈 제거, 대문자)
            const mac = decodedText.replace(/[:\-\s]/g, '').toUpperCase();
            this.tagRows[this.scanTargetIndex].tag_mac = mac;
            this.stopScan();
          },
          () => { /* ignore scan failures */ }
        ).catch((err) => {
          console.error('Camera start failed:', err);
          this.scanError = '카메라를 사용할 수 없습니다. 카메라 권한을 확인해주세요.';
        });
      });
    },
    stopScan() {
      if (this.html5Qrcode) {
        this.html5Qrcode.stop().then(() => {
          this.html5Qrcode.clear();
          this.html5Qrcode = null;
        }).catch(() => {
          this.html5Qrcode = null;
        });
      }
      this.showScanner = false;
    },
  },
  beforeUnmount() {
    this.stopScan();
  },
};
</script>

<style scoped>
.register-tag-container {
  padding: 20px;
}

.company-info {
  margin-bottom: 16px;
  color: #555;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
}

input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input[type="text"] {
  width: 100%;
}

.tag-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tag-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.mac-input-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  gap: 4px;
  align-items: center;
}

.mac-input-wrap .tag-mac {
  flex: 1;
  min-width: 0;
}

.btn-scan {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #4e73df;
  border-radius: 4px;
  background: #fff;
  color: #4e73df;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-scan:hover {
  background: #f0f4ff;
}

.btn-scan .material-symbols-outlined {
  font-size: 22px;
}

.tag-row .devicename {
  flex: 1;
  min-width: 0;
}

.btn-remove {
  flex-shrink: 0;
  width: 32px;
  height: 36px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.btn-remove:hover {
  background: #eee;
}

.btn-add {
  margin-top: 8px;
  padding: 8px 14px;
  border: 1px dashed #4e73df;
  border-radius: 4px;
  background: #fff;
  color: #4e73df;
  cursor: pointer;
  font-size: 14px;
}

.btn-add:hover {
  background: #f0f4ff;
}

.btn-submit {
  padding: 10px 20px;
  background-color: #4e73df;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.btn-submit:hover {
  background-color: #2e59d9;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  text-align: center;
  min-width: 280px;
}

.popup-content h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
}

.popup-content button {
  padding: 8px 16px;
  background: #4e73df;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.scanner-content {
  background: white;
  padding: 24px;
  border-radius: 8px;
  text-align: center;
  width: 90%;
  max-width: 400px;
}

.scanner-content h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
}

#qr-reader {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.scan-error {
  color: #e53935;
  font-size: 13px;
  margin-top: 8px;
}

.btn-cancel {
  margin-top: 12px;
  padding: 8px 20px;
  background: #999;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-cancel:hover {
  background: #777;
}
</style>
